import { type ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface CameraTopBarProps {
  /** Content for the left side (back button, refocus button) */
  left?: ReactNode;
  /** Primary center indicator (mode badge, header badge) */
  center?: ReactNode;
  /** Secondary center indicator below primary (status, error, capturing) */
  centerSecondary?: ReactNode;
  /** Content for the right side (torch button) */
  right?: ReactNode;
  className?: string;
}

/**
 * Floating top bar overlay for camera pages.
 * Provides a uniform three-column layout for buttons and status indicators
 * that sit on top of the camera view.
 */
export function CameraTopBar({ left, center, centerSecondary, right, className }: CameraTopBarProps) {
  return (
    <div className={cn('absolute top-0 left-0 right-0 z-20 pointer-events-none p-2', className)}>
      {/* Top row: left / center / right */}
      <div className="flex items-start justify-between">
        <div className="pointer-events-auto flex items-center gap-2 min-w-0 shrink-0">
          {left}
        </div>
        <div className="pointer-events-auto flex flex-col items-center gap-1 absolute left-1/2 -translate-x-1/2 max-w-[50%]">
          {center}
          {centerSecondary}
        </div>
        <div className="pointer-events-auto flex items-center gap-2 min-w-0 shrink-0">
          {right}
        </div>
      </div>
    </div>
  );
}
